<script>
import isMounted from 'linna/mixins/isMounted'

import Typewriter from '../snippets/Typewriter'
import SlowFade from '../transitions/SlowFade'

import Credits from '@/content/Credits.md'

export default {
  name: 'Credits',

  components: {
    SlowFade,
    Typewriter
  },

  mixins: [
    isMounted
  ],

  data () {
    return {
      Credits
    }
  },

  methods: {

    onTypewriterComplete () {
      this.$emit('complete')
    }

  }

}
</script>

<template>
  <div class="c-credits">
    <slow-fade :appear="true">

      <typewriter
        v-if="isMounted"
        :message="Credits"
        class="c-credits-content"
        @complete="onTypewriterComplete"
      />

    </slow-fade>
  </div>
</template>
